import React, { useEffect, useState } from 'react';
import { _T } from 'appI18n';
import { setupLoginControl } from 'inlineLogin.js';
export default function LoginToSeePricesButton() {
    const [open, setOpen] = useState(false);
    const bg = document.querySelector(".logon-background");
    // Модал приходит с разметкой, поэтому такой костыль.
    useEffect(() => {
        if (!bg)
            return;
        bg.style.display = open ? 'block' : 'none';
    }, [open]);
    useEffect(() => {
        var _a;
        if (!bg)
            return;
        (_a = bg.querySelector('.close')) === null || _a === void 0 ? void 0 : _a.addEventListener('click', _ => setOpen(false));
        setupLoginControl(() => window.location.reload());
    }, []);
    return (React.createElement("span", { className: "top-local-logon", onClick: () => setOpen(x => !x) }, _T.COMMON_LOGIN_TO_SEE_PRICES));
}
